import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom"
import { useSelector, useDispatch } from 'react-redux';

import { MEDIA_ORIGIN } from "../../utils/Environment";
import { getAppList, getSubscribedAppList, updateSubscribedAppList } from "../../lib/api";
import { useModal } from '../../store/ModalContext';
import { updateAppList, updateSubscribeAppList } from "../../redux/appSlice";
import LoadingSpinner from "../UI/LoadingSpinner";

const ListOfAppsToExplore = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const { appList, subscribedAppList } = useSelector((state) => state.app);
    const { openThankYouSubscribeModal } = useModal();
    const [isLoading, setIsLoading] = useState(false);

    const goToAppDetailPage = (selectedAppUrl) => {
        history.push(`/appdetail${selectedAppUrl}`)
    }

    const goToApp = (appUrl) => {
        window.open(appUrl, '_blank')
    }

    const handleSubscribedAppList = useCallback(() => {
        if (currentUser) {
            setIsLoading(true);
            getSubscribedAppList(currentUser)
                .then((response) => {
                    setIsLoading(false)
                    dispatch(updateSubscribeAppList(response));
                })
                .catch((error) => {
                    setIsLoading(false)
                    console.log(error);
                })
        }
    }, [currentUser, dispatch])

    const handleToBeSubscribeApp = (nid, popUpConsent) => {
        setIsLoading(true)
        const formData = {
            "nid": nid,
            "uid": currentUser.current_user.uid
        }
        updateSubscribedAppList(currentUser, formData)
            .then((response) => {
                if (response.status === "success") {
                    setIsLoading(false);
                    handleSubscribedAppList();
                    openThankYouSubscribeModal(popUpConsent);
                }
            })
            .catch((error) => {
                setIsLoading(false)
                console.log(error);
            })
    }

    useEffect(() => {
        handleSubscribedAppList()
        if (appList === null || appList.length === 0) {
            setIsLoading(true)
            getAppList(currentUser)
                .then((response) => {
                    const filteredAppList = currentUser ? response.filter(app => app.user_type.includes(currentUser.user_extra_details.user_type)) : response
                    dispatch(updateAppList(filteredAppList))
                    setIsLoading(false)
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false)
                })
        }
    }, [currentUser, appList, dispatch, handleSubscribedAppList]);

    return (
        <>
            {isLoading && (
                <div className="parentDisable">
                    <LoadingSpinner />
                </div>
            )}
            {currentUser && subscribedAppList.length > 0 &&
                <section className="section myAppsSection">
                    <div className="bg-white  px-5 sm:px-5 md:px-5 lg:px-14 py-6 sm:pt-6 md:pt-6 pb-4 lg:pb-8  lg:pt-10">
                        <h2 className="exploreTitle text-[#333] barlowBold uppercase text-xl sm:text-2xl leading-7 sm:leading-9 tracking-[-0.25px]">My Resources</h2>
                        <div className="appsGrid mt-6 lg:mt-8">
                            <div className="grid max-[460px]:grid-cols-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12  md:gap-20 myApps *:cursor-pointer">
                                {subscribedAppList.map((app, key) => {
                                    const isPending = parseInt(app.required_approval) === 1 && parseInt(app.approved) !== 1;

                                    return (
                                        <div
                                            title={isPending ? "Pending Approval" : ""}
                                            className={`apps flex flex-col gap-2 sm:gap-4 group ${isPending ? "pending" : ""}`}
                                            key={key}
                                            onClick={!isPending ? () => goToApp(app.web_app_url ? app.web_app_url : app.mobile_app_url) : null}
                                        >
                                            <div className="appIconHolder w-24 sm:w-[120px] grayscale-[40%] mx-auto">
                                                <img
                                                    src={`${MEDIA_ORIGIN}${app.icon}`}
                                                    className="w-full group-hover:grayscale-[40%]"
                                                    alt="course icon"
                                                />
                                            </div>
                                            <p className="appDesc barlowBold text-[#333] text-base sm:text-xl leading-6 tracking-[-0.05px] text-center group-hover:underline pb-1 decoration-[#0057B8] group-hover:text-[#0057B8] transition-all duration-500 ease-in-out">
                                                {app.title}
                                            </p>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>
                    </div>
                </section>
            }
            <section className="section introSection">
                {appList && appList.filter(item => !subscribedAppList.some(subscribedApp => subscribedApp.nid === item.nid)).length > 0 && <div className="px-5 sm:px-5 md:px-5 lg:px-14  py-8 lg:py-12">
                    <h2 className="exploreTitle text-[#333] barlowBold  text-xl sm:text-2xl leading-7 sm:leading-9 tracking-[-0.25px] uppercase">What resources would you like to add?</h2>
                    <div className="appsGrid mt-6 lg:mt-8">
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-x-14 gap-y-6 sm:gap-y-12 *:cursor-pointer">
                            {appList && appList.filter(item => !subscribedAppList.some(subscribedApp => subscribedApp.nid === item.nid)).map((detail, key) =>
                                <div className="app" key={key}>
                                    <div className="flex justify-between items-center gap-5">
                                        <div className="grid grid-cols-[auto,1fr] gap-4 sm:gap-6 w-full" onClick={() => goToAppDetailPage(detail.slug_url)}>
                                            <div className="appIconHolder w-12 sm:w-[72px]">
                                                <img src={`${MEDIA_ORIGIN}${detail.icon}`} className="w-full" alt="course icon" />
                                            </div>
                                            <div className="appInfo flex flex-col gap-1 sm:gap-2 justify-center">
                                                <h6 className="appTitle text-[#333] text-base leading-5 sm:text-lg font-medium sm:leading-6">{detail.title}</h6>
                                                <p className="text-[#333] text-xs leading-4 sm:text-base sm:leading-5 font-normal md:max-w-[70%] max-w-full lg:max-w-[80%]">{detail.summary}</p>
                                            </div>
                                        </div>

                                        {currentUser && <div className="appAdd" onClick={() => handleToBeSubscribeApp(detail.nid, detail.popup_consent)}>
                                            <button className="addApp text-primaryText font-medium text-sm sm:text-base leading-5  bg-[#F5F9FD] border border-[#7DA1C4] rounded-lg cursor-pointer w-[100px] h-9 flex justify-center items-center hover:bg-primaryBlue hover:text-white transition-all ease-out duration-300">Add</button>
                                        </div>}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>}
            </section>
        </>
    )
}

export default ListOfAppsToExplore;
